<template>
  <div
    class="modal fade"
    id="guideLine"
    role="dialog"
    @click="$emit('close')"
  >
    <div class="modal-dialog modal-xl" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body">
          <p class="text-size-20 font-bold">だれでも掲示板 ガイドライン</p>
          <div>
            以下の行為が見られた場合、投稿が削除されることがあります。<br><br>

            1. 侮辱、個人攻撃、悪意のある発言、卑猥な言葉、口汚い罵り、嫌がらせ、虐待、中傷、扇動的な発言など、無礼と見なされる可能性のある内容。<br>
            2. 人種、民族、国籍、性別、性自認、性的指向、宗教、年齢、身体障害などの特徴に基づく差別的または憎悪に満ちた内容。<br>
            3. 安全のため、電話番号、Eメールアドレス、個人住所、免許証番号、社会保障番号、銀行口座番号、クレジットカード番号、デビットカード番号、金融情報、IPアドレスなどの個人情報を記載しないでください。<br>
            4. 政治家候補、政党、政策に関する意見や発言などを含む政治的な内容。<br>
            5. 同じ投稿を複数回コピーして貼り付ける、迷惑なリンクを投稿するなど、スパムと見なされる可能性のある内容。<br>
            6. 他のセラーまたは団体になりすます行為。<br>
            7. 自社商品を売り込む行為。<br>
            8. 著作権、商標権、特許権、企業秘密などの知的財産権やその他の所有権を侵害する、または侵害する可能性のある内容。<br>
            9. その他、ご利用にあたり不適切であると当社が合理的な根拠に基づき判断する内容。<br><br>

            以上のガイドラインを守り、皆様が安全で快適にご利用いただけるようご協力をお願いします。
          </div>
        </div>
        <div class="modal-footer flexbox justify-right">
          <div data-dismiss="modal" @click="$emit('close')">
            <button class="btn ver-middle w-120">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  mounted () {
    $('#guideLine').modal('show')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/request/GuideLine.vue